import { render } from "./PayoutCompensation.vue?vue&type=template&id=409594fc&ts=true"
import script from "./PayoutCompensation.vue?vue&type=script&lang=ts"
export * from "./PayoutCompensation.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__